import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFloatingFormControl from 'UIComponents/form/UIFloatingFormControl';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import PropertyRecord from '../records/PropertyRecord';
import TaxonomyInputUtils from '../utils/TaxonomyInputUtils';
import { PRODUCT_INTEREST } from '../constants/ConversationsProperties';
import ThreadRecord from '../records/ThreadRecord';
import { jsx as _jsx } from "react/jsx-runtime";
const NOT_APPLICABLE = 'NOT_APPLICABLE';

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.

// @ts-expect-error ts-migrate(7022) FIXME: 'ProductInterestSelect' implicitly has type 'any' ... Remove this comment to see the full error message
const ProductInterestSelect = ({
  allProperties,
  currentValue,
  displayMode,
  isUpdatingProperty,
  onChange,
  ghosted,
  threadRecord
}) => {
  const FormWrapper = displayMode === 'card' ? UIFloatingFormControl : UIFormControl;
  const handleNotApplicableOption = value => {
    if (value[value.length - 1] === NOT_APPLICABLE) {
      return [NOT_APPLICABLE];
    }
    return value.filter(option => option !== NOT_APPLICABLE);
  };
  const shouldDisableInput = () => ghosted || !threadRecord.requiresProductAndTier();
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'FormWrapper' does not have any c... Remove this comment to see the full error message
    _jsx(FormWrapper, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.taxonomy.property.product.label"
      }),
      children: /*#__PURE__*/_jsx(UISelect, Object.assign({
        anchorType: "button"
      }, displayMode === 'panel' && {
        buttonUse: 'form'
      }, {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        className: displayMode === 'card' ? 'p-left-0' : null,
        "data-test-id": "product-interest-select-input",
        menuWidth: displayMode === 'panel' ? 350 : 250,
        multiCollapseLimit: 3,
        multi: true,
        onChange: ({
          target: {
            value
          }
        }) => {
          const adjustedValue = handleNotApplicableOption(value);
          onChange(new PropertyRecord({
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
            name: PRODUCT_INTEREST,
            value: adjustedValue,
            revisionCode: currentValue ? currentValue.revisionCode : 0
          }));
        },
        options: TaxonomyInputUtils.mapPropertiesToOptions({
          properties: allProperties,
          propertyKey: 'product',
          disabled: isUpdatingProperty,
          priorityValues: ['CRM_SUITE']
        }),
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.taxonomy.property.product.placeholder"
        }),
        readOnly: shouldDisableInput(),
        value: currentValue.value || null
      }))
    })
  );
};
ProductInterestSelect.propTypes = {
  allProperties: ImmutablePropTypes.list.isRequired,
  currentValue: PropTypes.instanceOf(PropertyRecord),
  displayMode: PropTypes.string.isRequired,
  ghosted: PropTypes.bool,
  isUpdatingProperty: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  threadRecord: PropTypes.instanceOf(ThreadRecord).isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
ProductInterestSelect.defaultProps = {
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
  currentValue: new PropertyRecord({
    name: PRODUCT_INTEREST
  }),
  ghosted: false
};
export default ProductInterestSelect;